import React from 'react';
import { CheckCircle2, ShieldAlert } from 'lucide-react';

interface AwardPlanStatusProps {
    estimateOnly: boolean;
    isAccepted: boolean;
    handoffEmails?: { queued: string[]; skipped: string[] };
}

/** What the award rests on, and who hears about it once confirmed. */
const AwardPlanStatus: React.FC<AwardPlanStatusProps> = ({ estimateOnly, isAccepted, handoffEmails }) => {
    const showEstimate = estimateOnly && !isAccepted;
    const handoff = isAccepted && handoffEmails && handoffEmails.queued.length + handoffEmails.skipped.length > 0
        ? handoffEmails
        : null;
    if (!showEstimate && !handoff) return null;
    return (
        <div className="flex flex-col gap-s3">
            {showEstimate && (
                <div className="flex items-start gap-s2 rounded-control border border-warn-border bg-warn-bg px-s4 py-s3 text-body-sm text-warn-ink">
                    <ShieldAlert className="mt-[1px] h-[13px] w-[13px] shrink-0" />
                    <span>
                        <span className="font-semibold">No supplier has committed a quote.</span>{' '}
                        This award would be based entirely on research estimates — the prices were scraped, not offered.
                        You can proceed, but sending RFQs from Supplier Outreach first gets you real numbers.
                    </span>
                </div>
            )}
            {handoff && (
                <div className="flex items-start gap-s2 rounded-control border border-line bg-surface-hover px-s4 py-s3 text-body-sm text-ink-secondary">
                    <CheckCircle2 className="mt-[1px] h-[13px] w-[13px] shrink-0 text-success-ink" />
                    <span>
                        {handoff.queued.length > 0 && (
                            <>I'm thanking <span className="font-semibold text-ink">{handoff.queued.join(', ')}</span> for their responses — no outcome is shared; you reach out directly for next steps. </>
                        )}
                        {handoff.skipped.length > 0 && (
                            <span className="text-warn-ink">Skipped {handoff.skipped.join(', ')} — no contact email on file.</span>
                        )}
                    </span>
                </div>
            )}
        </div>
    );
};

export default AwardPlanStatus;
